import { Component, ViewEncapsulation, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { ParseService } from 'app/shared/common/parse/parse.service';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { QueryInterface } from 'app/shared/common/parse/query-interface';
import { StorageConfiguration } from 'app/shared/common/storage-setting/storage-configuration';
import { DateServiceService } from 'app/shared/common/helper/dateservice';
import { HardCodedValues } from 'app/shared/common/hard-coded-values';
import { SelectItem } from 'primeng/primeng';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { fuseAnimations } from '@fuse/animations';
import _ from 'lodash';
import { ToastrService } from 'ngx-toastr';
import { TextToSpeechService } from '../../../../shared/common/helper/text-speech';
import { GetReportingToService } from 'app/shared/common/helper/get-reporting-to';
import { DatePipe } from '@angular/common';
import { ExcelService } from '../../scrumboard/excel.service';

@Component({
  selector: 'app-work-status',
  templateUrl: './work-status.component.html',
  styleUrls: ['./work-status.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  providers: [DatePipe]
})

export class WorkStatusComponent implements OnInit {


  checkInOutCol: Array<object> = [
    { field: 'position', header: 'S.No' },
    { field: 'image', header: 'Profile' },
    { field: 'name', header: 'Name' },
    { field: 'totalCheckInTime', header: 'Total Hours' },
  ]

  isDisabled: boolean = true;
  dataSettings: any;
  employeeStatus: any = [];
  type: string;
  totalRecords: any;
  reportsList = [];
  empRole = '';
  resources = [];
  resources1 = [];
  locationDD = [];
  locationOptions: SelectItem[];
  roleDD = [];
  report: any;
  reportingList = [];
  reportingToDD = [];
  rollOptions: SelectItem[];
  deptDD = [];
  deptOptions: SelectItem[];
  reportingToOptions: SelectItem[];
  allEmployees = [];
  twilightEmployees = [];
  projects: any[] = [];
  projectDetails: any[] = [];
  currentStatus = [];
  projectsList: any[] = [];
  projectInformation: any[] = [];
  projectMems = [];
  today: any;
  currentDate: any;
  barGraphData = [];
  barGraphValues: any;
  allTwilightEmployees = [];
  selectedProject: any = { name: '', id: '' };
  myControl = new FormControl();
  filteredOptions: Observable<any[]>;
  assignedResources: any[] = [];
  billable = [];
  nonBillable = [];
  graphValue: any;
  locationLabels = [];
  graphData = [];
  inTimeDatas = [];
  inTimeGraphValues = [];
  public chartOptions = {
    scales: {
      yAxes: [{
        ticks: {
          stepSize: 10,
          beginAtZero: true
        }
      }]
    }
  }
  lineChartValue = {};
  checkInOutDate: any;

  lineChart = { labels: ['BEFORE 09:30', '09:30 to 10:00', '10:00 to 10:30', '10:30 to 11:00', '11:00 to 11:30', '11:30 to 12:00', '12:00 to 12:30', 'AFTER 12:30'], datasets: [] };

  lineChartOptions = {
    layout: {
      padding: {
        left: 20,
        right: 20,
        top: 20,
        bottom: 20
      }
    },
    legend: {
      display: true,
      position: 'right',
      padding: 20,
    },
    elements: {
      line: {
        tension: 0, // disables bezier curves
        fill: false,
      },
      point: {
        radius: 4,
        hoverRadius: 5,
        pointStyle: 'rectRot',
        backgroundColor: 'red'
      }
    },
    tooltips: {
      mode: 'nearest'
    },
    scales: {
      yAxes: [{
        stacked: false,
        ticks: {
          min: 0,
          // max: 25,
          stepSize: 5,
          beginAtZero: true
        }
      }]
    }
  };

  cols = [
    { field: 'position', header: 'S. No' },
    { field: 'resourceImg', header: 'Profile' },
    { field: 'name', header: 'Name' },
    { field: 'totalExperience', header: 'Experience' },
    { field: 'location', header: 'Location' },
    { field: 'reportingTo', header: 'Reporter' },
    { field: 'designation', header: 'Designation' },
    { field: 'workHours', header: 'Work Hours' },
  ];

  checkCols = [
    { field: 'position', header: 'S.No' },
    { field: 'resourceImg', header: 'Profile' },
    { field: 'name', header: 'Name' },
    { field: 'reportingTo', header: 'Reporter' },
    { field: 'designation', header: 'Designation' },
    { field: 'agreedStartTime', header: 'Agreed StartTime' },
    { field: 'inTime', header: 'Check-In' },
    { field: 'workHours', header: 'Work Hours' },
    { field: 'breakHours', header: 'Break Hours' }
  ];

  colors = ['#A8385D', '#6DAB6C', '#A27EA8', '#E86666', '#3C8EE0'];

  assignedResourcesRecords: number;
  dataRefresher: any;
  graphMetrics: any;
  index = 0;
  selectbydate = new Date();
  projectListDetails = [];
  tabIndex: Number;
  supportBillableCount: any[];
  totalResources: any;
  billableCount: any[];
  addOnType: any;

  textMessage = '';
  show = false;
  marqueeMessage: string;
  projectFeedMessage = [];
  checkType: string = 'Check-In';

  projectStatus: any[] = [
    { value: 'Dedicated Billable', viewValue: 'Dedicated Billable' },
    { value: 'Dedicated Non-Billable', viewValue: 'Dedicated Non-Billable' },
    { value: 'Fixed Billable', viewValue: 'Fixed Billable' },
    { value: 'Fixed Non-Billable', viewValue: 'Fixed Non-Billable' }
  ];
  textLabel: any;

  startDate: Date = new Date();
  endDate: Date = new Date();
  selectedRole: string = '';
  selectedEmployee: string = '';

  public barChartOptions: any = {
    // scaleShowVerticalLines: false,
    // animation: {
    //   onComplete: function () {
    //     var chartInstance = this.chart,
    //       ctx = chartInstance.ctx;
    //     ctx.textAlign = 'center';
    //     ctx.textBaseline = 'bottom';
    //     this.data.datasets.forEach(function (dataset, i) {
    //       var meta = chartInstance.controller.getDatasetMeta(i);
    //       meta.data.forEach(function (bar, index) {
    //         var data = dataset.data[index];
    //         ctx.fillText(data, bar._model.x, bar._model.y - 5);
    //       });
    //     });
    //   }
    // },
    // responsive: true,
    // options: {
    //   scales: {
    //     yAxes: [{
    //       ticks: {
    //         reverse: false,
    //         stepSize: 20
    //       },
    //     }]
    //   }
    // }
  };
  public barChartLabels = [];
  public barChartType: string = 'bar';
  public barChartLegend: boolean = true;
  public barChartData = [];
  public barChartColors: any[] = [
    {
      backgroundColor: '#C8F2C1'
    },
    {
      backgroundColor: '#F5ECB5'
    },
    {
      backgroundColor: '#D8D8D8'
    },
    {
      backgroundColor: '#FFA9A9'
    },
  ];
  tenantId: '';
  checkInCheckOutEmployees: any[];
  checkInCount: number = 0;
  checkInOutTotalCount: number = 0;
  checkOutCount: number = 0;
  checkInOutCount: number = 0;
  notCheckInOutCount: any = Math.abs((this.checkOutCount + this.checkInCount) - this.checkInOutTotalCount);
  checkOutTime: any;
  totalEmployeeList: number = 0;
  employeesList: any = [];
  last7Day: any;
  checkInOutInfo: any = [];
  checkTotalCount: number = 0;

  constructor(private spinner: NgxSpinnerService,
    private parseService: ParseService,
    public dialog: MatDialog,
    private queryInterface: QueryInterface,
    private storageConfiguration: StorageConfiguration,
    private router: Router,
    private dateService: DateServiceService,
    private hardCodedValues: HardCodedValues,
    private toastr: ToastrService,
    private getReportingToService: GetReportingToService,
    private datePipe: DatePipe,
    private textToSpeechService: TextToSpeechService,
    private excelService: ExcelService,
  ) {
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.getCheckOutDetails();
    this.getCheckInDetails();
    this.last7Days();
  }

  async ngOnInit() {
    this.empRole = this.storageConfiguration.sessionGetItem(this.storageConfiguration.role);
    this.getLocation();
    // this.getEmployees();
    let profileClass = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(profileClass);
    query.equalTo('isActive', true);
    query.equalTo('isLongLeave', false);
    query.include('location');
    query.include('department');
    query.equalTo('tenantId', this.tenantId);
    query.include('role');
    query.limit(10000000);
    await query.find().then(async results => {

      this.twilightEmployees = JSON.parse(JSON.stringify(results));
      this.refreshData();

      await this.selectTab(0);
    });
  }

  last7Days() {
    var result = [];
    for (var i = 0; i < 7; i++) {
      var d = new Date();
      d.setDate(d.getDate() - i);
      result.push(d);
      this.checkInOutCol.push({ field: this.datePipe.transform(d, "MMM d"), header: this.datePipe.transform(d, "MMM d") })
    }
    this.last7Day = result;
  }

  /*
  ** ==========================================================
  ** Get list of locations
  ** ==========================================================
  */
  async getLocation() {
    let result = [];
    this.locationLabels = [];
    await this.getReportingToService.getLocation().then(results => {
      this.locationOptions = this.bindDropDown(results);
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let departmentInfo = JSON.parse(jsonText);
        result.push({ label: departmentInfo.label, id: departmentInfo.value });
        this.locationLabels.push(departmentInfo.label);
      }
      this.locationDD = result;
    });
  }

  bindDropDown(array: any[]): any[] {
    const dropDownItem = [];
    if (array != undefined) {
      array.forEach(a => {
        dropDownItem.push({ label: a.label, value: a.label });
      });
    }
    return dropDownItem;
  }

  getRollOption() {
    let result = [];
    this.queryInterface.queryRoleAll(this.parseService).then(results => {
      for (let i = 0; i < results.length; i++) {
        let jsonText = JSON.stringify(results[i]);
        let roleList = JSON.parse(jsonText);
        // result.push({ label: roleList.name, id: roleList.objectId });

        if (roleList.displayName) {
          result.push({ label: roleList.displayName, id: roleList.role.objectId });
        }
        else {
          result.push({ label: roleList.name, id: roleList.objectId });
        }

      }
      this.roleDD = result;
      this.rollOptions = this.bindDropDown(this.roleDD);
    });
  }

  /*
  ** ==========================================================
  ** Get reporintg to details
  ** ==========================================================
  */
  async getReportingTo() {
    await this.getReportingToService.getReportingTo().then(res => {
      this.reportingToOptions = this.bindDropDown(res);
    });
  }

  /*
  ** ==========================================================
  ** Getting the latest data every 5 minutes
  ** ==========================================================
  */
  refreshData() {
    this.dataRefresher = setInterval(async () => {
      await this.getUserMetrics();
      await this.getBiggbossMetrics();
      // await this.getUserTimesheet();
    }, 300000);
  }

  ngOnDestroy() {
    if (this.dataRefresher) {
      clearInterval(this.dataRefresher);
    }
  }

  /*
  ** ==========================================================
  ** Get Employees Metrics(Work, Idle, Log out, Not logged In)
  ** ==========================================================
  */
  getUserMetrics() {
    this.allEmployees = JSON.parse(JSON.stringify(this.twilightEmployees));
    this.graphData = [];
    this.spinner.show();
    let condition = [];
    let type;
    let dateDifferent = this.dateService.startEndDateByDate(new Date());
    condition = [
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'profileId' },
      { condition: 'include', value: 'user.profile' },
      { condition: 'include', value: 'user.profile.location' },
      { condition: 'include', value: 'user.profile.role' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'limit', value: 1000000 },
      { condition: 'greaterThan', field: 'createdAt', value: dateDifferent[0] },
      { condition: 'lessThan', field: 'createdAt', value: dateDifferent[1] },
    ];
    type = 'UserTimeSheet';
    let employeeStatus = [];

    this.queryInterface.executeQuery(this.parseService, type, condition).then(async results => {

      results.forEach(element => {
        let profileId = element.get('user').get('profile').id
        let find = this.allEmployees.findIndex(x => x.objectId == profileId);
        this.allEmployees.splice(find, 1);
      });

      let onWorkEmployee = results.filter(x => (x.get('currentStatus') === 'work') && (x.get('isClosed') === false));
      employeeStatus.push({ name: 'Work', resources: onWorkEmployee });

      let idleEmployee = results.filter(x => (x.get('currentStatus') === 'idle') && (x.get('isClosed') === false));
      employeeStatus.push({ name: 'Idle', resources: idleEmployee });

      let logoutEmployee = results.filter(x => x.get('isClosed') === true);
      employeeStatus.push({ name: 'Logged Out', resources: logoutEmployee });

      employeeStatus.push({ name: 'Not Yet Login', resources: this.allEmployees });

      this.employeeStatus = employeeStatus;

      this.cardClick(this.employeeStatus[0]);
      this.spinner.hide();

    });

  }

  cardClick(event): any {

    this.resources = [];
    this.type = event.name;
    if (event.name === 'Not Yet Login') {
      this.resources = this.getNotYetLogin(event.resources);
    }
    else {
      this.resources = this.getResources(event.resources);
    }
    this.totalRecords = this.resources.length;
  }

  /*
  ** ==========================================================
  ** Get Resource Details(Work, Idle, Log out, Not logged In)
  ** ==========================================================
  */
  getResources(resources): any {
    // this.spinner.show();
    let result = [];
    for (const element of resources) {
      let profile = element.get('user').get('profile');
      let location = element.get('user').get('profile').get('location').get('name');
      let reportingTo = '';
      var myObj = profile.get('reportingTo').get('profileImageInfo');
      if (this.isEmpty(myObj)) {
        // Object is empty
        reportingTo = this.hardCodedValues.defaultProfileImg;
      } else {
        // Object is NOT empty
        reportingTo = profile.get('reportingTo').get('profileImageInfo').url
      }
      let reporter = element.get('user').get('profile').get('reportingTo').get('username');
      let designation = element.get('user').get('profile').get('role').get('name');

      let experienceInYear = (profile.get('officialInfo').experience != undefined) && (profile.get('officialInfo').experience.year != undefined)
        && (profile.get('officialInfo').experience.year != '') ? profile.get('officialInfo').experience.year : 0;
      let experienceInMonth = (profile.get('officialInfo').experience != undefined) && (profile.get('officialInfo').experience.month != undefined) &&
        (profile.get('officialInfo').experience.month != '') ? profile.get('officialInfo').experience.month : 0;
      let totalExperience = (experienceInYear + '.' + experienceInMonth + ' Year(s)');
      let totalAttendance = element.get('totalAttendance');

      let isPushed = result.find(x => x.id == profile.id);
      if (isPushed == undefined) {
        result.push({
          id: profile.id,
          position: 0,
          resourceImg: profile.get('profileImageInfo').url == undefined ? this.hardCodedValues.defaultProfileImg : profile.get('profileImageInfo').url,
          name: profile.get('firstName') + ' ' + profile.get('lastName'),
          location: location,
          reportingTo: reportingTo,
          designation: designation,
          reporter: reporter,
          totalExperience: totalExperience,
          experience: Number(experienceInYear + '.' + experienceInMonth),
          workHours: this.secondsToHms(totalAttendance.worktime),
          outTime: element.get('outTime')
        });
      }

    }
    let res = result;
    res.sort(numberAs);
    function numberAs(a, b) {
      return b.experience - a.experience;
    }
    res.forEach((element, i) => {
      element.position = i + 1;
    });
    
    return res;
  }

  secondsToHms(d) {
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor((d % 3600) / 60);
    let s = Math.floor((d % 3600) % 60);

    let hDisplay = (h <= 9 ? '0' : '') + h;
    let mDisplay = (m <= 9 ? '0' : '') + m;
    let sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  isEmpty(obj) {
    for (var key in obj) {
      if (obj.hasOwnProperty(key))
        return false;
    }
    return true;
  }

  getNotYetLogin(resources): any {
    this.spinner.show();
    let result = [];
    resources.forEach(element => {
      let location = element.location ? element.location.name : '';
      let reportingTo = '';
      var myObj = element.reportingTo.profileImageInfo;
      if (this.isEmpty(myObj)) {
        // Object is empty
        reportingTo = this.hardCodedValues.defaultProfileImg;
      } else {
        // Object is NOT empty
        reportingTo = element.reportingTo.profileImageInfo.url
      }
      let reporter = element.reportingTo.username;
      let role = element.role.name;

      let experienceInYear = (element.officialInfo.experience != undefined) && (element.officialInfo.experience.year != undefined)
        && (element.officialInfo.experience.year != '') ? element.officialInfo.experience.year : 0;
      let experienceInMonth = (element.officialInfo.experience != undefined) && (element.officialInfo.experience.month != undefined) &&
        (element.officialInfo.experience.month != '') ? element.officialInfo.experience.month : 0;
      let totalExperience = (experienceInYear + '.' + ' ' + experienceInMonth + ' Year(s)');

      result.push({
        position: 0,
        resourceImg: element.profileImageInfo.url == undefined ? this.hardCodedValues.defaultProfileImg : element.profileImageInfo.url,
        name: element.firstName + ' ' + element.lastName,
        location: location,
        reportingTo: reportingTo,
        designation: role,
        reporter: reporter,
        totalExperience: totalExperience,
        experience: Number(experienceInYear + '.' + experienceInMonth),
        workHours: '0'
      });
    });
    // let res = result.sort((a, b) => a.name.localeCompare(b.name));
    let res = result;
    res.sort(numberAs);
    function numberAs(a, b) {
      return b.experience - a.experience;
    }
    res.forEach((element, i) => {
      element.position = i + 1;
    });
    this.spinner.hide();
    return res;
  }

  /*
  ** ==========================================================
  ** Tab Change Event
  ** ==========================================================
  */
  selectTab(index): void {
    this.spinner.show();
    if (index == 0) {
      this.tabIndex = 0;
      this.getBiggbossMetrics();

      this.getUserMetrics();
      this.getRollOption();
      this.getReportingTo();
    }
    else if (index == 1) {
      this.tabIndex = 1;
      this.getInTimeMetrics(new Date());
    }
    else if (index == 2) {
      this.tabIndex = 2;
      this.getCheckInDetails();
      this.getCheckOutDetails();
    }
  }

  dayafter(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() + 1));
  }

  daybefore(d) {
    let day = new Date(d);
    return new Date(day.setDate(day.getDate() - 1));
  }

  startenddates(day) {
    let startdate = this.daybefore(new Date(day));
    startdate.setHours(23, 59, 59, 999);
    let enddate = this.dayafter(day);
    enddate.setHours(0, 0, 0, 0);
    return [startdate, enddate];
  }

  /*
  ** ==========================================================
  ** Get Bigboss Metrics Graph(Work, Idle, Log out, Not logged In)
  ** ==========================================================
  */
  getBiggbossMetrics() {

    this.spinner.show();
    let condition = [];
    let type;
    let timesheetResult = [];
    let userTimesheetResults = [];
    let dateDifferent = this.dateService.startEndDateByDate(new Date());
    condition = [
      { condition: 'include', value: 'user' },
      { condition: 'include', value: 'profileId' },
      { condition: 'include', value: 'profileId.location' },
      { condition: 'include', value: 'user.profile.role' },
      { condition: 'limit', value: 1000000 },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'greaterThan', field: 'createdAt', value: dateDifferent[0] },
      { condition: 'lessThan', field: 'createdAt', value: dateDifferent[1] },
    ];
    type = 'UserTimeSheet';
    let locationDetails = [];
    this.queryInterface.executeQuery(this.parseService, type, condition).then(async results => {

      timesheetResult = JSON.parse(JSON.stringify(results));
      timesheetResult.forEach(element => {
        if (element.profileId != undefined) {
          userTimesheetResults.push(element);
        }
      });
      this.barChartLabels = [];
      this.barChartData = [];
      // let userTimesheetResults = JSON.parse(JSON.stringify(results));

      this.allTwilightEmployees = JSON.parse(JSON.stringify(this.twilightEmployees));

      results.forEach(element => {
        if (element.get('profileId') != undefined) {
          let profileId = element.get('profileId').id
          let find = this.allTwilightEmployees.findIndex(x => x.objectId == profileId);
          this.allTwilightEmployees.splice(find, 1);
        }
      });

      this.locationOptions.forEach(element => {
        let locationArray = userTimesheetResults.filter(x => x.profileId.location.name === element.label);
        locationDetails.push({ name: element.label, resources: locationArray });
        this.barChartLabels.push(element.label);
      });
      let workData = [];
      let idleData = [];
      let logoutData = [];
      let notLoggedData = [];

      locationDetails.forEach((res, index) => {
        this.barGraphData = [];
        this.barGraphValues = {};

        let work = res.resources.filter(x => x.currentStatus == 'work' && x.isClosed == false);
        let idle = res.resources.filter(x => x.currentStatus == 'idle' && x.isClosed == false);
        let logout = res.resources.filter(x => x.isClosed == true);
        let notLoggedIn = this.allTwilightEmployees.filter(x => x.location.name == res.name);

        workData.push(work.length);
        idleData.push(idle.length);
        logoutData.push(logout.length);
        notLoggedData.push(notLoggedIn.length);

        if (index == locationDetails.length - 1) {
          this.barGraphData.push({ label: 'Work', backgroundColor: '#b0f762', borderColor: '#b0f762', data: workData });
          this.barGraphData.push({ label: 'Idle', backgroundColor: '#fbe693', borderColor: '#fbe693', data: idleData });
          this.barGraphData.push({ label: 'Logout', backgroundColor: '#525050', borderColor: '#525050', data: logoutData });
          this.barGraphData.push({ label: 'Not Logged In', backgroundColor: '#ef6a5d', borderColor: '#ef6a5d', data: notLoggedData });

          this.barChartData.push({ label: 'Work', data: workData });
          this.barChartData.push({ label: 'Idle', data: idleData });
          this.barChartData.push({ label: 'Logout', data: logoutData });
          this.barChartData.push({ label: 'Not Logged In', data: notLoggedData });

        }

        this.barGraphValues = {
          labels: this.locationLabels,
          datasets: this.barGraphData
        }
        this.spinner.hide();
      });
    });
  }

  /*
  ** ==========================================================
  ** Get In Time Metrics(Work, Idle, Log out, Not logged In)
  ** ==========================================================
  */
  async getInTimeMetrics(date) {
    this.spinner.show();

    this.inTimeDatas = [];
    let timesheetResult = [];

    this.lineChartValue = [];
    this.lineChart.datasets = [];
    let dateDifferent = this.dateService.startEndDateByDate(new Date(date));
    let userClass = this.parseService.instance.Object.extend('UserTimeSheet');
    let query = new this.parseService.instance.Query(userClass);
    query.greaterThan('createdAt', dateDifferent[0]);
    query.lessThan('createdAt', dateDifferent[1]);
    query.include('profileId');
    query.include('profileId.location');
    query.limit(10000000);
    query.equalTo('tenantId', this.tenantId);
    await query.find().then(results => {

      timesheetResult = JSON.parse(JSON.stringify(results));
      timesheetResult.forEach(element => {
        if (element.profileId != undefined) {
          this.inTimeDatas.push(element);
        }
      });

      // this.inTimeDatas = JSON.parse(JSON.stringify(results));

      let before0930 = this.inTimeDatas.filter(x => x.inTime <= (new Date(date).setHours(9, 30)));
      let bt930to10 = this.inTimeDatas.filter(x => x.inTime > (new Date(date).setHours(9, 30)) && x.inTime <= (new Date(date).setHours(10, 0)));
      let bt10to1030 = this.inTimeDatas.filter(x => x.inTime > (new Date(date).setHours(10, 0)) && x.inTime <= (new Date(date).setHours(10, 30)));
      let bt1030to11 = this.inTimeDatas.filter(x => x.inTime > (new Date(date).setHours(10, 30)) && x.inTime <= (new Date(date).setHours(11, 0)));
      let bt11to1130 = this.inTimeDatas.filter(x => x.inTime > (new Date(date).setHours(11, 0)) && x.inTime <= (new Date(date).setHours(11, 30)));
      let bt1130to12 = this.inTimeDatas.filter(x => x.inTime > (new Date(date).setHours(11, 30)) && x.inTime <= (new Date(date).setHours(12, 0)));
      let bt12to1230 = this.inTimeDatas.filter(x => x.inTime > (new Date(date).setHours(12, 0)) && x.inTime <= (new Date(date).setHours(12, 30)));
      let aftera1230 = this.inTimeDatas.filter(x => x.inTime > (new Date(date).setHours(12, 30)));
      const location = this.locationDD.map(function (getLocation) {
        return getLocation.label;
      });
      location.forEach((element, index) => {
        let before930 = before0930.filter(x => x.profileId.location.name == element);
        let between930to10 = bt930to10.filter(x => x.profileId.location.name == element);
        let between10to1030 = bt10to1030.filter(x => x.profileId.location.name == element);
        let between1030to11 = bt1030to11.filter(x => x.profileId.location.name == element);
        let between11to1130 = bt11to1130.filter(x => x.profileId.location.name == element);
        let between1130to12 = bt1130to12.filter(x => x.profileId.location.name == element);
        let between12to1230 = bt12to1230.filter(x => x.profileId.location.name == element);
        let after1230 = aftera1230.filter(x => x.profileId.location.name == element);
        // let data = [before930.length, between930to10.length, between10to1030.length, between1030to11.length, between11to1130.length, between1130to12.length, between12to1230.length, after1230.length];

        let data = [before930.length,
        between930to10.length + before930.length,
        between10to1030.length + between930to10.length + before930.length,
        between1030to11.length + between10to1030.length + between930to10.length + before930.length,
        between11to1130.length + between1030to11.length + between10to1030.length + between930to10.length + before930.length,
        between1130to12.length + between11to1130.length + between1030to11.length + between10to1030.length + between930to10.length + before930.length,
        between12to1230.length + between1130to12.length + between11to1130.length + between1030to11.length + between10to1030.length + between930to10.length + before930.length,
        after1230.length + between12to1230.length + between1130to12.length + between11to1130.length + between1030to11.length + between10to1030.length + between930to10.length + before930.length
        ];
        let sets = {
          label: element,
          data,
          borderColor: this.colors[index],
          backgroundColor: this.colors[index],
        }
        this.spinner.hide();
        this.lineChart.datasets.push(sets);
      });
      this.lineChartValue = this.lineChart;
    });
  }

  onFilter(event, dt): any {
    event.filteredValue.forEach((element, index) => {
      element.position = index + 1;
    });
    this.totalRecords = event.filteredValue.length;
  }

  /*
  ** ==========================================================
  ** Getting Today's Date
  ** ==========================================================
  */

  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }

  viewProject(projectId, typeOfProject, route) {
    this.router.navigate(['project-detail', { id: projectId, index: 3, projectType: typeOfProject, route: route }]);
  }

  async goToSprint(projectId, projectName) {
    let result = [];
    let queryInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(queryInstance);
    query.include('project');
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: projectId });
    await query.find().then(results => {
      result = results;
      if (result.length > 0) {
        this.router.navigate(['/scrumboard/board/sprint/' + projectId + '/' + projectName]);
      }
      else {
        this.toastr.warning('Please create backlog board');
      }
    });
  }

  viewProjectDashboard(projectId) {
    this.router.navigate(['projectdashboard', { id: projectId }]);
  }

  getMarqueeMessage() {
    // this.http.get('assets/Issues.txt').subscribe(data => {
    //   let marqueeMessage = (data.text()).replace(/(\r\n|\n|\r)/gm, "");
    //   this.marqueeMessage = marqueeMessage;
    // });
    this.projectFeedMessage = [];
    let projectFeed = this.parseService.instance.Object.extend('ProjectFeeds');
    let query = new this.parseService.instance.Query(projectFeed);
    let dateDifferent = this.dateService.startEndDateByDate(new Date());
    query.greaterThan('createdAt', dateDifferent[0]);
    query.lessThan('createdAt', dateDifferent[1]);
    query.include('projectId');
    query.find().then(res => {
      res.forEach(element => {
        this.projectFeedMessage.push(element.get('message'));
      });
      this.marqueeMessage = this.projectFeedMessage.join(". ").replace(/(\r\n|\n|\r)/gm, "");
    });
  }

  resumeVoice() {
    this.textToSpeechService.resume();
  }

  startVoice() {
    this.textToSpeechService.start(this.marqueeMessage);
  }

  readingTextFile() {
    this.show = !this.show;
    if (this.show == true) {
      this.textToSpeechService.pause();
    }
    else {
      this.textToSpeechService.resume();
    }
  }

  getCheckInDetails() {
    
    this.checkInCheckOutEmployees = [];
    this.spinner.show();
    this.checkCols = [];
    // this.checkInCount = 0;
    this.checkCols.push({ field: 'position', header: 'S.No' },
      { field: 'resourceImg', header: 'Profile' },
      { field: 'name', header: 'Name' },
      { field: 'reportingTo', header: 'Reporter' },
      { field: 'designation', header: 'Designation' },
      { field: 'agreedStartTime', header: 'Agreed StartTime' },
      { field: 'inTime', header: 'Check-In' },
      { field: 'workHours', header: 'Work Hours' },
      { field: 'breakHours', header: 'Break Hours' });

    this.checkType = 'Check-In';
    let startend = this.startenddates(this.checkInOutDate ? this.checkInOutDate : new Date());

    let condition = [
      { condition: 'include', value: 'profile' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'limit', value: 1000000 },
      { condition: 'equalTo', field: 'currentStatus', value: 'in' },
      { condition: 'greaterThan', field: 'checkInDate', value: startend[0] },
      { condition: 'lessThan', field: 'checkInDate', value: startend[1] },
      { condition: 'descending', field: 'checkInDate' }
    ];
    let type = 'CheckInCheckout';
    this.queryInterface.executeQuery(this.parseService, type, condition).then(async results => {
      if (results.length > 0) {
        this.checkInCheckOutEmployees = [];
        // this.checkInCount = 0;
        this.checkInCount = results.length;
        this.checkInOutCount = this.checkInCount;
        let i = 0;
        for (let data of results) {
          let checkInTotalWorkHours = data.get('totalWorkHours') ? data.get('totalWorkHours') : '00:00';
          let checkOutTotalWorkHours = data.get('totalBreakHours') ? data.get('totalBreakHours') : '00:00';
          let checkInTime = new Date(data.get('inTime'));

          i = i + 1
          let checkInOutInfo = {
            position: i,
            id: data.id,
            resourceImg: data.get('profile').get('profileImageInfo').url,
            name: data.get('profile').get('username'),
            reportingTo: data.get('profile').get('reportingTo').get('username'),
            designation: data.get('profile').get('role').get('name'),
            reporter: data.get('profile').get('reportingTo').get('username'),
            workHours: checkInTotalWorkHours,
            breakHours: checkOutTotalWorkHours,
            inTime: checkInTime,
            agreedStartTime: data.get('profile').get('officialInfo').startTime,
            esslUserId: data.get('esslUserCode')
          }
          let removeDuplicateData = this.checkInCheckOutEmployees.filter(x => x.esslUserId == data.get('esslUserCode'));
          if (removeDuplicateData.length === 0) {
            this.checkInCheckOutEmployees.push(checkInOutInfo);
          }
        }
      }
      else {
        this.checkInCheckOutEmployees = [];
      }
    });
    this.spinner.hide();
  }

  getCheckOutDetails(data?: any) {
    
    this.checkInCheckOutEmployees = [];
    this.spinner.show();
    // this.checkOutCount = 0;
    this.checkCols = [];
    this.checkCols.push({ field: 'position', header: 'S.No' },
      { field: 'resourceImg', header: 'Profile' },
      { field: 'name', header: 'Name' },
      { field: 'reportingTo', header: 'Reporter' },
      { field: 'designation', header: 'Designation' },
      { field: 'outTime', header: 'Check-Out' },
      { field: 'workHours', header: 'Work Hours' },
      { field: 'breakHours', header: 'Break Hours' });

    this.checkType = 'Check-Out';
    let startend = this.startenddates(this.checkInOutDate ? this.checkInOutDate : new Date());
    let condition = [
      { condition: 'include', value: 'profile' },
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'limit', value: 1000000 },
      { condition: 'equalTo', field: 'currentStatus', value: 'out' },
      { condition: 'greaterThan', field: 'checkInDate', value: startend[0] },
      { condition: 'lessThan', field: 'checkInDate', value: startend[1] }
    ];

    let type = 'CheckInCheckout';
    this.queryInterface.executeQuery(this.parseService, type, condition).then(async results => {
      if (results.length > 0) {
        this.checkInCheckOutEmployees = [];
        // this.checkOutCount = 0;
        this.checkOutCount = results.length;
        this.checkInOutCount = this.checkOutCount;
        let i = 0;
        for (let data of results) {

          let checkInTotalWorkHours = data.get('totalWorkHours') ? data.get('totalWorkHours') : '00:00';
          let checkOutTotalWorkHours = data.get('totalBreakHours') ? data.get('totalBreakHours') : '00:00';
          let checkInTime = new Date(data.get('outTime'));

          i = i + 1
          let checkInOutInfo = {
            position: i,
            id: data.id,
            resourceImg: data.get('profile').get('profileImageInfo').url,
            name: data.get('profile').get('username'),
            reportingTo: data.get('profile').get('reportingTo').get('username'),
            designation: data.get('profile').get('role').get('name'),
            reporter: data.get('profile').get('reportingTo').get('username'),
            workHours: checkInTotalWorkHours,
            breakHours: checkOutTotalWorkHours,
            outTime: checkInTime,
            esslUserId: data.get('esslUserCode')
          }

          let removeDuplicateData = this.checkInCheckOutEmployees.filter(x => x.esslUserId == data.get('esslUserCode'));
          if (removeDuplicateData.length === 0) {
            this.checkInCheckOutEmployees.push(checkInOutInfo);
          }
        }

      }
    });
    this.spinner.hide();
  }

  getEmployeeCount() {
    let startend = this.startenddates(this.checkInOutDate ? this.checkInOutDate : new Date());
    this.checkInOutTotalCount = 0;
    let condition = [
      { condition: 'equalTo', field: 'tenantId', value: this.tenantId },
      { condition: 'limit', value: 1000000 },
      { condition: 'greaterThan', field: 'checkInDate', value: startend[0] },
      { condition: 'lessThan', field: 'checkInDate', value: startend[1] }
    ];

    this.checkInCheckOutEmployees = [];
    let type = 'CheckInCheckout';
    this.queryInterface.executeQuery(this.parseService, type, condition).then(async results => {
      if (results.length > 0) {
        this.checkInOutTotalCount = 0;
        this.checkInOutTotalCount = results.length;
      }
    });
  }

  exportToExcel() {
    this.excelService.exportAsExcelFile(this.checkInCheckOutEmployees, 'Employees Check-In/Out');
  }

  async takePreviousData(event: any) {
    this.checkInOutDate = event.value._d;
    this.getCheckOutDetails();
    this.getCheckInDetails();
  }

  async getEmployees() {
    this.spinner.show();
    await this.getCheckInOutInfo();
    let roleList = [];
    roleList.push('02aT5OLR5T', '4DSvEtvL3C', '5sWIDTj5CF', 'y8J9WamN1K', 'vFcHQmBI4A');
    let queryInstance = this.parseService.instance.Object.extend('Profile');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.equalTo('isActive', true);
    query.limit(1000);
    query.include('department');
    query.include('role');
    query.equalTo('isLongLeave', false);
    query.ascending('username');
    query.containedIn('role', roleList)
    query.find().then(async result => {
      let i = 0;
      if (result.length > 0) {
        this.checkTotalCount = result.length - 1;
        this.employeesList = [];
        for (let data of result) {
          if (data.get('username') != 'Admin Twilight') {
            i = i + 1;
            let check = await this.checkInOutInfo.filter(x => x.profileId == data.id);
            var totalCheckInTime = "00:00"
            if (check.length > 0) { totalCheckInTime = await this.calculateWorkHours(check); }
            if (Object.keys(data.get('profileImageInfo')).length > 0) { var profileImage = data.get('profileImageInfo').url }
            else { var profileImage: any = ''; }
            let profileDetails: any = {
              position: i,
              id: data.id,
              name: data.get('username'),
              role: data.get('role').get('name'),
              department: data.get('department').get('name'),
              image: profileImage,
              totalCheckInTime
            }
            for (let t of check) {
              profileDetails[`${t.checkInDate}`] = t.checkInTotalWorkHours;
            }
            this.employeesList.push(profileDetails);
            this.spinner.hide();
          }
        }
      } else {
        this.spinner.hide();
        this.employeesList = [];
      }
    });
  }

  async getCheckInOutInfo() {

    let dateStart = this.dateService.startEndDateByDate(this.last7Day[6]);
    let dateEnd = this.dateService.startEndDateByDate(this.last7Day[0]);

    let queryInstance = this.parseService.instance.Object.extend('CheckInCheckout');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('tenantId', this.tenantId);
    query.greaterThan('checkInDate', dateStart[0]);
    query.lessThan('checkInDate', dateEnd[1]);
    query.include('profile.role');
    query.descending('checkInDate');
    query.limit(100000000000);
    let result = await query.find()
    if (result.length > 0) {
      this.checkInOutInfo = [];
      for (let data of result) {
        let checkInTotalWorkHours = data.get('totalWorkHours') ? data.get('totalWorkHours') : '00:00';
        let checkOutTotalWorkHours = data.get('totalBreakHours') ? data.get('totalBreakHours') : '00:00';
        this.checkInOutInfo.push({
          id: data.id,
          checkInTotalWorkHours,
          checkOutTotalWorkHours,
          checkInDate: this.datePipe.transform(data.get('checkInDate'), 'MMM d'),
          profileId: data.get('profile').id
        });
      }
    } else {
      this.checkInOutInfo = [];
    }
  }

  calculateWorkHours(time) {
    var hour: any = 0;
    var minute: any = 0;
    for (let d of time) {
      const [hours, minutes] = d.checkInTotalWorkHours.split(':');
      hour = Number(hours) + hour;
      minute = (Number(minutes) + minute);
    }

    if (minute >= 60) {
      let min = Math.floor(minute / 60) + ':' + minute % 60;
      const [hors, mins] = min.split(':');
      hour = hour + Number(hors);
      minute = mins;
    }

    return `${hour < 10 ? `0${hour}` : hour}:${minute < 10 ? `0${minute}` : minute}`;
  }



  // downloadCheckInOutList() {
  //   let dateStart = this.dateService.startEndDateByDate(this.startDate);
  //   let dateEnd = this.dateService.startEndDateByDate(this.endDate);
  //   let queryInstance = this.parseService.instance.Object.extend('CheckInCheckout');
  //   let query = new this.parseService.instance.Query(queryInstance);
  //   query.equalTo('tenantId', this.tenantId);
  //   query.greaterThan('checkInDate', dateStart[0]);
  //   query.lessThan('checkInDate', dateEnd[1]);
  //   query.include('profile.role');
  //   query.ascending('checkInDate');
  //   query.limit(100000000000);
  //   query.find().then(result => {
  //     if (result.length > 0) {
  //     } else {
  //     }
  //   });
  // }

}
